export const META_ADS_CLICK_ID_QUERY_PARAM = "fbclid";
export const META_ADS_CLICK_ID_STORAGE_KEY = "tapestry:metaAds:fbclid";
const INTERNAL_URL_ORIGIN = "https://ads.openai.com";
const MAX_META_ADS_CLICK_ID_LENGTH = 256;
const META_ADS_ROLLOUT_COUNTRIES = new Set(["AU", "CA", "GB", "JP", "KR", "NZ", "US"]);

export function isMetaAdsRolloutCountry(countryCode: string | undefined): boolean {
  return countryCode != null && META_ADS_ROLLOUT_COUNTRIES.has(countryCode.toUpperCase());
}

export function isMetaAdsRolloutCountryHeader(
  countryHeader: string | string[] | null | undefined,
): boolean {
  const countryCode = Array.isArray(countryHeader) ? countryHeader[0] : countryHeader;
  return isMetaAdsRolloutCountry(countryCode?.trim() || undefined);
}

export function getMetaAdsClickId(searchParams: URLSearchParams): string | undefined {
  const values = searchParams.getAll(META_ADS_CLICK_ID_QUERY_PARAM);
  if (values.length !== 1) return undefined;

  const rawValue = values[0];
  const value = rawValue?.trim();
  if (!value || value !== rawValue || !isValidMetaAdsClickId(value)) {
    return undefined;
  }
  return value;
}

export function appendMetaAdsClickIdToPath(path: string, clickId: string | undefined): string {
  try {
    const url = new URL(path, INTERNAL_URL_ORIGIN);
    if (url.origin !== INTERNAL_URL_ORIGIN) return path;

    url.searchParams.delete(META_ADS_CLICK_ID_QUERY_PARAM);
    if (clickId && isValidMetaAdsClickId(clickId)) {
      url.searchParams.set(META_ADS_CLICK_ID_QUERY_PARAM, clickId);
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return path;
  }
}

function isValidMetaAdsClickId(value: string): boolean {
  return (
    value.trim() === value &&
    value.length > 0 &&
    value.length <= MAX_META_ADS_CLICK_ID_LENGTH &&
    !Array.from(value).some((character) => {
      const codePoint = character.codePointAt(0) ?? 0;
      return codePoint <= 0x1f || codePoint === 0x7f;
    })
  );
}
